
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/my-profile",
      function () {
        return require("private-next-pages/account/my-profile/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/my-profile"])
      });
    }
  